import { render, staticRenderFns } from "./MainTaskWindow.component.vue?vue&type=template&id=4c97d9ba&scoped=true&"
import script from "./MainTaskWindow.component.vue?vue&type=script&lang=js&"
export * from "./MainTaskWindow.component.vue?vue&type=script&lang=js&"
import style0 from "./MainTaskWindow.component.vue?vue&type=style&index=0&id=4c97d9ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c97d9ba",
  null
  
)

export default component.exports